import api from './apiClient';
import { InventoryItem, InventoryItemCreatePayload, InventoryItemUpdatePayload, InventoryMovement, InventoryMovementCreatePayload } from '../types';

export const inventoryService = {
  getItems: async (params?: {
    clinic_id?: number;
    search?: string;
    include_inactive?: boolean;
  }): Promise<InventoryItem[]> => {
    const response = await api.get('/inventory/items', { params });
    return response.data;
  },

  createItem: async (payload: InventoryItemCreatePayload): Promise<InventoryItem> => {
    const response = await api.post('/inventory/items', payload);
    return response.data;
  },

  updateItem: async (id: number, payload: InventoryItemUpdatePayload): Promise<InventoryItem> => {
    const response = await api.put(`/inventory/items/${id}`, payload);
    return response.data;
  },

  createMovement: async (itemId: number, payload: InventoryMovementCreatePayload): Promise<InventoryMovement> => {
    const response = await api.post(`/inventory/items/${itemId}/movements`, payload);
    return response.data;
  },

  getMovements: async (itemId: number): Promise<InventoryMovement[]> => {
    const response = await api.get(`/inventory/items/${itemId}/movements`);
    return response.data;
  },
};








